import React from 'react';
import Hero from '../components/Hero';
import Services from '../components/Services';
import About from '../components/About';
import HowItWorks from '../components/HowItWorks';
import WhyChooseUs from '../components/WhyChooseUs';
import Statistics from '../components/Statistics';
import Testimonials from '../components/Testimonials';
import PaymentInfo from '../components/PaymentInfo';
import WhatToExpect from '../components/WhatToExpect';

const Home = ({ onContactClick, onBookClick }) => {
  return (
    <div className="main-page">
      <Hero />
      <div className="content-wrapper">
        <Services />
        <WhyChooseUs />
        <Statistics />
        <About />
        <HowItWorks />
        <WhatToExpect onBookClick={onBookClick} />
        <PaymentInfo onContactClick={onContactClick} />
        <Testimonials onContactClick={onContactClick} />
      </div>
    </div>
  );
};

export default Home; 